import { render, staticRenderFns } from "./StepBar.vue?vue&type=template&id=7e51d968&scoped=true&"
import script from "./StepBar.vue?vue&type=script&lang=ts&"
export * from "./StepBar.vue?vue&type=script&lang=ts&"
import style0 from "./StepBar.vue?vue&type=style&index=0&id=7e51d968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e51d968",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
